import React from 'react';
import { FileText, Bot, QrCode, Users, Info, MessageCircle, Send, Image, FolderArchive, Upload, Mail } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    { number: "1", icon: FileText, title: "Persiapan Informasi", description: "Keluarga menyiapkan informasi inti" },
    { number: "2", icon: Bot, title: "Setup AI Agent", description: "Tim Kenangan.AI menyiapkan AI Agent dan QR Code" },
    { number: "3", icon: QrCode, title: "Penempatan QR Code", description: "QR Code ditaruh di meja penerima tamu" },
    { number: "4", icon: Users, title: "Tamu Berinteraksi", description: "Tamu scan dan chat via WhatsApp" }
  ];

  const guestFeatures = [
    { icon: Info, text: "Menampilkan informasi resmi" },
    { icon: MessageCircle, text: "Menjawab kebutuhan informasi tamu" },
    { icon: Send, text: "Mengundang tamu mengirim doa dan pesan" },
    { icon: Image, text: "Menerima foto dan video dari tamu secara real-time" }
  ];

  const finalSteps = [
    {
      icon: FolderArchive,
      text: "Mengompilasi semua pesan, foto, dan video"
    },
    {
      icon: Upload,
      text: "Mengirimkan hasilnya kepada keluarga"
    },
    {
      icon: Mail,
      text: "Pengiriman via WhatsApp atau Email bila file besar"
    }
  ];

  return (
    <section id="cara-kerja" className="py-20 bg-funeral-secondary">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-4xl md:text-5xl font-serif text-center text-funeral-gold mb-4">
          Cara Kerja
        </h2>
        <div className="divider"></div>

        <div className="space-y-16">
          <div>
            <h3 className="text-2xl font-serif text-center text-funeral-light mb-8">Cara Mulai</h3>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {steps.map((step) => {
                const IconComponent = step.icon;
                return (
                  <div key={step.number} className="bg-funeral-dark p-6 rounded-sm border border-funeral-border text-center hover:border-funeral-gold transition-all group">
                    <div className="relative mb-4">
                      <div className="w-16 h-16 bg-funeral-gold text-funeral-dark rounded-full flex items-center justify-center text-2xl font-serif mx-auto group-hover:scale-110 transition-transform">
                        {step.number}
                      </div>
                      <div className="absolute -top-2 -right-2 bg-funeral-gold/20 p-2 rounded-full">
                        <IconComponent className="text-funeral-gold" size={20} />
                      </div>
                    </div>
                    <h4 className="text-lg font-serif text-funeral-light mb-2">{step.title}</h4>
                    <p className="text-funeral-light text-sm">{step.description}</p>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="border-t border-funeral-border pt-12">
            <h3 className="text-2xl font-serif text-center text-funeral-light mb-8">Saat Tamu Chat</h3>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {guestFeatures.map((feature, index) => {
                const IconComponent = feature.icon;
                return (
                  <div key={index} className="bg-funeral-dark p-6 rounded-sm border border-funeral-border text-center hover:border-funeral-gold transition-all group">
                    <div className="bg-funeral-gold/10 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                      <IconComponent className="text-funeral-gold" size={24} />
                    </div>
                    <p className="text-funeral-light text-sm">{feature.text}</p>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="border-t border-funeral-border pt-12">
            <h3 className="text-2xl font-serif text-center text-funeral-light mb-8">Setelah Prosesi Selesai</h3>
            <div className="grid md:grid-cols-3 gap-8">
              {finalSteps.map((step, index) => {
                const IconComponent = step.icon;
                return (
                  <div key={index} className="text-center bg-funeral-dark p-6 rounded-sm border border-funeral-border hover:border-funeral-gold transition-all group">
                    <div className="text-funeral-gold mb-4 flex justify-center">
                      <div className="bg-funeral-gold/10 p-4 rounded-full group-hover:bg-funeral-gold/20 transition-all">
                        <IconComponent size={32} />
                      </div>
                    </div>
                    <p className="text-funeral-light">{step.text}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
